module.exports = __webpack_public_path__ + "img/skillsA-5.32794855.png";